import "./FloatingAstronaut.css";

const FloatingAstronaut = () => {
  return (
    <>
      <div>
        <a
          href="https://icons8.com/illustrations/author/zD2oqC8lLBBA"
          target="_blank"
          className="floating-astronaut__link"
          rel="noopener noreferrer"
        >
          <img
            className="floating-astronaut"
            src="/images/floating-astronaut.gif"
            alt=""
          />
        </a>
      </div>
    </>
  );
};

export default FloatingAstronaut;
// Illustration by <a >Icons 8</a> from <a href="https://icons8.com/illustrations">Ouch!</a>
